export const ORGANIZER_ADD_REQUEST = "ORGANIZER_ADD_REQUEST";
export const ORGANIZER_ADD_SUCCESS = "ORGANIZER_ADD_SUCCESS";
export const ORGANIZER_ADD_FAIL = "ORGANIZER_ADD_FAIL";

export const ORGANIZER_DETAIL_REQUEST = "ORGANIZER_DETAIL_REQUEST";
export const ORGANIZER_DETAIL_SUCCESS = "ORGANIZER_DETAIL_SUCCESS";
export const ORGANIZER_DETAIL_FAIL = "ORGANIZER_DETAIL_FAIL";

export const ORGANIZER_UPDATE_REQUEST = "ORGANIZER_UPDATE_REQUEST";
export const ORGANIZER_UPDATE_SUCCESS = "ORGANIZER_UPDATE_SUCCESS";
export const ORGANIZER_UPDATE_FAIL = "ORGANIZER_UPDATE_FAIL";

export const ORGANIZER_DELETE_REQUEST = "ORGANIZER_DELETE_REQUEST";
export const ORGANIZER_DELETE_SUCCESS = "ORGANIZER_DELETE_SUCCESS";
export const ORGANIZER_DELETE_FAIL = "ORGANIZER_DELETE_FAIL";

export const ORGANIZER_LIST_REQUEST = "ORGANIZER_LIST_REQUEST";
export const ORGANIZER_LIST_SUCCESS = "ORGANIZER_LIST_SUCCESS";
export const ORGANIZER_LIST_FAIL = "ORGANIZER_LIST_FAIL";

export const ORGANIZER_USER_LIST_REQUEST = "ORGANIZER_USER_LIST_REQUEST";
export const ORGANIZER_USER_LIST_SUCCESS = "ORGANIZER_USER_LIST_SUCCESS";
export const ORGANIZER_USER_LIST_FAIL = "ORGANIZER_USER_LIST_FAIL";
